import React from 'react';
import { makeStyles, SwipeableDrawer, Tab, Tabs } from '@material-ui/core';

interface Props {
    tosSource: string | null;
    showTabs: boolean;
    tabIndex: number;
    onClose: () => void;
    onChange: (_: any, value: number) => void;
}
const useStyles = makeStyles(() => ({
    dragger: {
        height: '8px',
        backgroundColor: '#d9d9d9',
        position: 'absolute',
        top: 0,
        left: '50%',
        width: '20%',
        transform: 'translateX(-50%)',
        borderRadius: '2rem',
        marginBottom: '5px',
    },
}));
const TermsAndPrivecyAndCaliforniaNoticeDrawer = ({
    tosSource,
    showTabs,
    tabIndex,
    onClose,
    onChange,
}: Props) => {
    const classes = useStyles();
    return (
        <>
            <SwipeableDrawer
                anchor="bottom"
                open={!!tosSource}
                onClose={onClose}
                onOpen={() => console.log('open')}
            >
                <div className={classes.dragger} />
                {showTabs && (
                    <Tabs
                        style={{ justifyContent: 'center', marginTop: '8px' }}
                        value={tabIndex}
                        onChange={onChange}
                        aria-label="simple tabs example"
                    >
                        <Tab label="Staples" />
                        <Tab label="Easy Rewards" />
                    </Tabs>
                )}
                {tabIndex === 0 && (
                    <iframe
                        id="privacy-link"
                        title="privacy link iFrame"
                        style={{ height: '90vh', width: '100%', marginTop: 16 }}
                        src={tosSource || '#'}
                    />
                )}
                {tabIndex === 1 && (
                    <iframe
                        id="privacy-link"
                        title="privacy link iFrame"
                        style={{ height: '90vh', width: '100%', marginTop: 16 }}
                        src={tosSource || '#'}
                    />
                )}
            </SwipeableDrawer>
        </>
    );
};

export default TermsAndPrivecyAndCaliforniaNoticeDrawer;
